import {Component, forwardRef, Inject, OnInit} from '@angular/core';
import {AlertService} from '../services/alert.service';

import {AlertMessage} from "./AlertMessage";
import {Router} from "@angular/router";
import {SessionService} from "../services/session.service";
import {Utils} from "../model/Utils";

// import {Ng2Notify, Ng2NotifyService} from "ng2-notify/notify";

@Component({
    selector: 'alert',
    templateUrl: 'alert.component.html',
})

export class AlertComponent implements OnInit {
    private static _message: any = null;
    private static _messages = new Array();
    constructor(
      @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
      @Inject(forwardRef(() => Router)) private router: Router,
      @Inject(forwardRef(() => SessionService)) public session: SessionService,
    ){

    }
    /*
    constructor(private alertService: AlertService, private notifyService: Ng2NotifyService) {
      this.notifyService.config({
        corner:'left-top',
        delay: 5000
      })

    }
    */

    public get message(){
      return AlertComponent._message;
    }

  public get messageAsAlertMessage():AlertMessage{
    return <AlertMessage>AlertComponent._message;
  }



  public get hasChatMessage(){
    // console.log('Checking if Chat Message');
    if (this.hasMessage === true){
       // console.log('Checking if Chat Message ? ' + AlertComponent._message.type);
      if ('chat' === AlertComponent._message.type){
        // console.log('This is a chat message!');
        return true;
      }
    }else{
      // console.log('No Message! ' + AlertComponent._messages.length + ' messages in list.');
    }
    return false;
  }


  public get hasMessage(){
      if (AlertComponent._message){
        return true;
      }
      return false;
      /*
      if (Utils.isNullOrUndefined(this._message)){
        return false;
      }
      return true;

       */
    }


    private _subscribe(){
     // console.log('Subscribing to alertService.');
      this.alertService.getMessage().subscribe( (message) => {
//          console.log('alert.component.ts receive message ',message);
          AlertComponent._message = message;
//          this.cd.detectChanges();
          if (!Utils.isNullOrUndefined(AlertComponent._message)){
            AlertComponent._messages.push(AlertComponent._message);
            if ('chat' === AlertComponent._message.type){
              console.log('This is a chat message');
            }
            if ('success' === AlertComponent._message.type){
              setInterval(()=>{
                  this.hideMessage();
                },5000 // 5sec.
              ); // 10 sec
            }else if ('chat' === AlertComponent._message.type){
              setInterval(()=>{
                  this.hideMessage();
                },4000 // 5sec.
              ); // 10 sec
            }else{

              setInterval(()=>{
                this.hideMessage();
                },20000 // 20sec.
              ); // 10 sec
            }
          }

        },
        (error) => {
          console.log('alert.component.ts error' + error);
        },
        ()  => {
          console.log('alert.component.ts completed');
        }
      );

    }



    public ngAfterContentInit() {
    /*
       console.log('alert.component.ts initialized.');
      setTimeout(()=> {
        this._subscribe();
      }, 100);
      */
    }

    public ngAfterViewInit(){

    }

  public hideMessage(){
      // console.log('Clearing Message');
    AlertComponent._message = null;
     AlertComponent._messages.length = 0;
  }

  public viewMessage(){
    this.router.navigate([this.session.homePath + '/chats'],{queryParams:{channelId:this.messageAsAlertMessage.chatChannelId}});
  }


  ngOnInit(): void {
    this._subscribe();
  }


}
